import { db } from '../FirebaseConfig';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Grava log de download no Firestore (coleção: audit_logs)
export const logFactory = async (item) => {
  try {
    const auth = getAuth();
    const userEmail = auth.currentUser?.email || 'unknown';
    const payload = {
      user_email: String(userEmail),
      s3_bucket: String(item?.Bucket ?? ''),
      s3_key: String(item?.Key ?? ''),
      created_at: serverTimestamp(),
    };

    await addDoc(collection(db, 'audit_logs'), payload);
    return true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Erro ao registrar log no Firestore', error);
    return false;
  }
};